var map = {
	"./CPO.png": "23f2",
	"./HU.png": "403a",
	"./HU.svg": "b7fc",
	"./MarburgUB.svg": "9b66",
	"./MarburgUNI.svg": "d08b",
	"./UZHschwarz.png": "6127",
	"./UZHweiss.png": "3500",
	"./UZHweiss.svg": "bb7d",
	"./alles.svg": "54e8",
	"./alr.png": "0287",
	"./andreasheusler.png": "1856",
	"./bgb.png": "fdc8",
	"./bluntschli.png": "4084",
	"./bv.png": "d579",
	"./dresdenerEntwurf.png": "90dd",
	"./ehrlich.png": "5205",
	"./eugenHuber.png": "6433",
	"./gierke.png": "e5e5",
	"./hgb.png": "08d7",
	"./iurisprudentiaS.png": "fc27",
	"./iurisprudentiaSW.png": "bb3e",
	"./iurisprudentiaW.png": "1bcc",
	"./iurisprudentia_Merriweather.png": "0a42",
	"./iurisprudentia_Merriweather.svg": "7d6e",
	"./jhering.png": "232c",
	"./keller.png": "081a",
	"./kempin.png": "56d8",
	"./locre.png": "65a3",
	"./logo-readcoop.png": "3fdb",
	"./logo-readcoop.svg": "daac",
	"./logo-readcoop1.png": "73dc",
	"./logo-readcoop1.svg": "662d",
	"./logo-readcoop2.png": "e8bc",
	"./logo-readcoop2.svg": "8f86",
	"./logo-unibe.svg": "c62a",
	"./logo-uzh.svg": "2fee",
	"./logo-winbib.png": "ee3c",
	"./logo-winbib.svg": "cd20",
	"./mackenroth.png": "8390",
	"./mommsen.png": "64ad",
	"./partner1.svg": "f314",
	"./partner2.svg": "71e1",
	"./partner3.svg": "96a2",
	"./planck.png": "7e2d",
	"./polor.png": "2531",
	"./polor.svg": "d92b",
	"./reichsJustizGesetze.png": "7140",
	"./reichskammergericht.png": "e916",
	"./rkg.png": "c194",
	"./rossel.png": "6022",
	"./saechsbgb.png": "1108",
	"./savigny.png": "b449",
	"./schweizerischesObligationenrecht.png": "84df",
	"./schweizerischesZivilgesetzbuch.png": "fc5a",
	"./test1.png": "b325",
	"./test2.png": "c3395",
	"./test3.png": "6aa6",
	"./unger.png": "1d15",
	"./vonGlueck.png": "34f0",
	"./vontuhr.png": "7235",
	"./warnkoenig.png": "2f7e",
	"./warschau.svg": "b9de",
	"./wetzlar.svg": "2c51",
	"./windscheid.png": "ff31",
	"./zb.png": "8598",
	"./zb.svg": "e5a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22d1";